import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 229px;
    height: 194px;
    padding: 25px 34px;
    background: #1c4f4c;
    border-radius: 10px;
    color: #ffffff;
    @media screen and (max-width: 576px) {
        height: auto;
    }
`;
export const Title = styled.div`
    font-weight: 500;
    font-size: 21px;
    line-height: 22px;
`;
export const List = styled.ul`
    list-style: none;
    padding-left: 0;
`;
export const Item = styled.li`
    font-weight: 400;
    font-size: 17px;
    line-height: 31px;
    position: relative;
    display: block;
    padding-left: 20px;
    position: relative;
    &:before {
        content: url('/icons/check.svg');
        position: absolute;
        top: 0;
        left: 0;
        color: #ffffff;
    }
`;
export const Link = styled.a`
    text-decoration: none;
    display: block;
    color: #27605c;
    background-color: #ffaa04;
    border-radius: 52px;
    font-size: 16px;
    line-height: 19px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    padding: 10px 0;
`;
